import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectActualsFromSellTo = createSelector(
  [selectPartner360Data],
  ({ actualsFromSellTo }) => actualsFromSellTo
)
